// import { useEffect, useState } from "react";
import { getSeoData } from "./Seodata";
import { PagejsonLd } from "./fetchdata";

export default function SEO({ FullURL }: { FullURL: string }) {
    const seoData = getSeoData(FullURL);

    const siteURL = process.env.NEXT_PUBLIC_FRONTEND_URL;

    // const [seoData, setSeoData] = useState<any>(getSeoData(FullURL));

    // useEffect(() => {
    //     getSeoData(FullURL).then(setSeoData);
    // }, [FullURL]);
    return (
        <>
            <title>{seoData?.seo_title || "JBcodeapp Transform Your Business with Web Design & Dev"}</title>
            <meta name="description" content={seoData?.seo_description || "Discover JBcodeapp expert services in web design, website development, and digital marketing. Let us boost your online presence and business success."} />
            <meta name="keywords" content={seoData?.seo_keyword || "It Support,Web design, Website development, Digital marketing, Mobile app development, Online presence, Business success"} />

            <link rel="canonical" href={siteURL + FullURL || siteURL} />

            {/* SEO OG INFO */}
            <meta property="og:locale" content="en_US" />
            <meta property="og:site_name" content={process.env.NEXT_PUBLIC_SITE_NAME || "GetBiz Solutions"} />
            <meta property="og:url" content={siteURL + FullURL || siteURL} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={seoData?.seo_title || "JBcodeapp Transform Your Business with Web Design & Dev"} />
            <meta property="og:description" content={seoData?.seo_description || "Discover JBcodeapp expert services in web design, website development, and digital marketing. Let us boost your online presence and business success."} />
            <meta property="og:image" content={seoData?.og_image || `${siteURL}/default_seo_image.webp`} />
            <meta name="og:image:width" content="1200" />
            <meta name="og:image:height" content="630" />
            <meta name="og:image:alt" content={process.env.NEXT_PUBLIC_SITE_NAME || "JBcodeapp"} />
            <meta name="og:image:type" content="image/webp" />

            {/* SEO TWITTER INFO */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta property="twitter:title" content={seoData?.seo_title || "JBcodeapp Transform Your Business with Web Design & Dev"} />
            <meta property="twitter:site_name" content={process.env.NEXT_PUBLIC_SITE_NAME || "JBcodeapp"} />
            <meta name="twitter:site" content="@jbcodeapp" />
            <meta property="twitter:url" content={siteURL + FullURL} />
            <meta property="twitter:description" content={seoData?.seo_description || "Discover JBcodeapp expert services in web design, website development, and digital marketing. Let us boost your online presence and business success."} />
            <meta property="twitter:image" content={seoData?.og_image || `${siteURL}/default_seo_image.webp`} />
            <meta name="twitter:image:width" content="1200" />
            <meta name="twitter:image:height" content="630" />
            <meta name="twitter:image:alt" content={process.env.NEXT_PUBLIC_SITE_NAME || "JBcodeapp"} />
            <meta name="twitter:image:type" content="image/webp" />

            <meta name="robots" content="index, follow" />

            {seoData?.blog === true && (
                <>
                    <meta property="article:published_time" content={seoData?.created_date} />
                    <meta property="article:modified_time" content={seoData?.updated_date} />
                </>
            )}

            {/* Organization */}
            {seoData?.ld_json && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(seoData?.ld_json) || JSON.stringify(PagejsonLd)
                    }}
                />
            )}

            {/* Breadcrumb JSON-LD */}
            {seoData?.breadcrumb && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: seoData?.breadcrumb }}
                />
            )}

            {/* FAQ JSON-LD */}
            {seoData?.faq && seoData.faq.length > 0 && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(seoData.faq) }}
                />
            )}

            {/* JSON-LD for Product */}
            {/* {metadata.product && metadata.product.length > 0 && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(metadata.product) }}
                />
            )} */}

            {/* {seoData?.additionalldjson.length > 0 && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(seoData?.additionalldjson) }}
                />
            )} */}


        </>
    );
}
